import React, { useState, useRef, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from "./components/Home";
import Conversation from "./components/Conversation";
import translations from "./translations.json";

function App() {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [language, setLanguage] = useState(() => {
    return localStorage.getItem("selectedLanguage") || "amharic";
  });
  const languages = [
    { value: "amharic", label: "አማርኛ" },
    { value: "oromo", label: "Afaan Oromoo" },
  ];

  const dropdownRef = useRef(null);
  const buttonRef = useRef(null);

  const toggleDropdown = () => setIsDropdownOpen((prev) => !prev);

  const handleLanguageSelect = (lang) => {
    setLanguage(lang.value);
    setIsDropdownOpen(false);
    localStorage.setItem("selectedLanguage", lang.value);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target) &&
        buttonRef.current &&
        !buttonRef.current.contains(event.target)
      ) {
        setIsDropdownOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const languageDropdown = (
    <div className="relative z-100" ref={dropdownRef}>
      <button
        ref={buttonRef}
        className="flex items-center  z-50 gap-2 text-xs text-[#161A61] px-3 py-2 rounded-md"
        onClick={toggleDropdown}
      >
        <span>{languages.find((l) => l.value === language)?.label}</span>
        <svg
          className={`w-4 h-4 z-100 transform ${
            isDropdownOpen ? "rotate-180" : ""
          }`}
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 20 20"
          fill="currentColor"
        >
          <path
            fillRule="evenodd"
            d="M14.707 10.293a1 1 0 010 1.414L10 16.414l-4.707-4.707a1 1 0 011.414-1.414L10 13.586l3.293-3.293a1 1 0 011.414 0z"
            clipRule="evenodd"
          />
        </svg>
      </button>
      {isDropdownOpen && (
        <ul className="absolute right-0 mt-2 bg-white rounded-md shadow-lg w-36 z-50">
          {languages.map((lang) => (
            <li
              key={lang.value}
              className="px-4 py-2 hover:text-blue-500  cursor-pointer"
              onClick={() => handleLanguageSelect(lang)}
            >
              {lang.label}
            </li>
          ))}
        </ul>
      )}
    </div>
  );

  const getTranslation = (key) => translations[language][key];

  return (
    <Router>
      <Routes>
        <Route
          path="/"
          element={
            <Home
              languageDropdown={languageDropdown}
              getTranslation={getTranslation}
            />
          }
        />
        <Route
          path="/conversation"
          element={
            <Conversation
              languageDropdown={languageDropdown}
              getTranslation={getTranslation}
              selectedLanguage={language}
            />
          }
        />
      </Routes>
    </Router>
  );
}

export default App;
